import { Suspense, useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import ListOfRoutes from "./config";
import { motion } from "framer-motion";
import Loader from "../components/loader";
import AppModal from "../components/modal";
import { useDispatch } from 'react-redux';
import { ACTIONS } from "../redux/actions";

async function externalItems({ dispatch }: any) {
  const university = require("../universities.json");
  const university2 = require("../universities-2.json");
  const countries = require("../countries.json");
  const courses = require("../courses.json");
  let local: any = [];
  for (let item of university) {
    for (let key in item) {
      local = [...local, ...Object.values(item[key])]
    }
  }
  dispatch({ type: ACTIONS.COMBO, combos: { universities: [...(university2?.map((value: any) => value.name) || []), ...local], courses, countries } });
}
export default function IndexRoutes(): JSX.Element {
  const dispatch = useDispatch()
  useEffect(() => {
    externalItems({ dispatch })
  }, [])
  return (<HelmetProvider>
    <Suspense fallback={<div className="loading">loading</div>}>
      {/* <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        style={{
        }}
      > */}
      <ListOfRoutes />
      {/* </motion.div> */}
    </Suspense>
    <Loader />
    <AppModal />
  </HelmetProvider >)
}
